import { isSeller } from "src/utils/userTypes";

export const ORDER_ID_QUERY_PARAM = "order_id";

const SELLER_ORDER_LINK_KEY = "sellerOrderDeepLinkId";

/** Seller All Orders tab. */
export const SELLER_ALL_ORDERS_TAB = "1";

export const parseOrderIdQuery = (raw) => {
  const id = String(raw ?? "").trim();
  return /^\d{1,20}$/.test(id) ? id : "";
};

export const readOrderIdQuery = (search = "") => {
  const query = String(search).startsWith("?")
    ? String(search).slice(1)
    : String(search);
  return parseOrderIdQuery(new URLSearchParams(query).get(ORDER_ID_QUERY_PARAM));
};

export const sellerOrdersDeepLink = (orderId) =>
  `/dashboard/orders?${ORDER_ID_QUERY_PARAM}=${encodeURIComponent(orderId)}`;

/** Logged-out order links land on login and keep the id in the query. */
export const loggedOutOrderLinkPath = (orderId) => {
  const id = parseOrderIdQuery(orderId);
  return id ? `/login?${ORDER_ID_QUERY_PARAM}=${encodeURIComponent(id)}` : "";
};

export const rememberSellerOrderDeepLink = (orderId) => {
  const id = parseOrderIdQuery(orderId);
  if (!id || typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(SELLER_ORDER_LINK_KEY, id);
};

export const consumeSellerOrderDeepLink = () => {
  if (typeof sessionStorage === "undefined") return "";
  const id = parseOrderIdQuery(sessionStorage.getItem(SELLER_ORDER_LINK_KEY));
  sessionStorage.removeItem(SELLER_ORDER_LINK_KEY);
  return id;
};

/**
 * After login, sellers with a stored order link go to All Orders search.
 * Other user types drop the stored link.
 */
export const takeSellerOrderDeepLinkPath = (userType) => {
  if (!isSeller(userType)) {
    consumeSellerOrderDeepLink();
    return "";
  }

  const id = consumeSellerOrderDeepLink();
  return id ? sellerOrdersDeepLink(id) : "";
};
